// extracted by mini-css-extract-plugin
export default {"container":"toast-notifications_container__THTpw"};